export const LANGUAGES = [
  { value: 'cpp', monaco: 'cpp' },
  { value: 'python', monaco: 'python' },
  { value: 'javascript', monaco: 'javascript' },
  { value: 'java', monaco: 'java' },
];

export const monacoLanguage = (value) => LANGUAGES.find((item) => item.value === value)?.monaco ?? 'plaintext';
